/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.modals.remove.controllers', [])

.controller('PassesModalsRemoveController', ['$scope', '$uibModalInstance', 'listItem', function($scope, $uibModalInstance, listItem) {

    $scope.passesModalsRemove = {

      model: {},

      init: function() {
        if (listItem) {
          this.model = listItem;
        }
      },

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }


    };

    $scope.passesModalsRemove.init();

}]);